import { FieldProps } from '../../pages/base/FieldProps';
import ExpenseCategoryStore from '../../stores/ExpenseCategoryStore';
import ExpenseStore from '../../stores/ExpenseStore';
import ExpenseTypeStore from '../../stores/ExpenseTypeStore';
import PaymentMethodStore from '../../stores/PaymentMethodStore';
import StoreStore from '../../stores/StoreStore';

export const getCardExpenseDisplayFieldProps = (
  expenseStore: ExpenseStore,
  expenseTypeStore: ExpenseTypeStore,
  expenseCategoryStore: ExpenseCategoryStore,
  storeStore: StoreStore,
  paymentMethodStore: PaymentMethodStore
) => {
  const columns: FieldProps[] = [
    {
      dataType: 'DateInput',
      placeholder: 'Expense Date',
      title: 'Date',
      propName: 'transactionDate',
      required: true,
      requiredMsg: 'Expense date is required',
      sorted: 'descending',
    },
    {
      dataType: 'SelectInput',
      placeholder: 'Expense Type',
      title: 'Type',
      propName: 'expenseTypeId',
      displayPropName: 'expenseType.typeName',
      required: true,
      requiredMsg: 'Expense type is required',
      store: expenseTypeStore,
    },
    {
      dataType: 'SelectInput',
      placeholder: 'Expense Category',
      title: 'Category',
      propName: 'expenseCategoryId',
      displayPropName: 'expenseCategory.expenseCategoryValue',
      required: true,
      requiredMsg: 'Expense category is required',
      store: expenseCategoryStore,
    },
    {
      dataType: 'SelectInput',
      placeholder: 'Store',
      title: 'Store',
      propName: 'storeId',
      displayPropName: 'store.storeName',
      required: true,
      requiredMsg: 'Store is required',
      store: storeStore,
    },
    {
      dataType: 'SelectInput',
      placeholder: 'Payment Method',
      title: 'Payment Method',
      propName: 'cardId',
      displayPropName: 'card.methodName',
      required: true,
      requiredMsg: 'Payment method is required',
      store: paymentMethodStore,
      notVisibleInEdit: true,
    },
    {
      dataType: 'CurrencyInput',
      placeholder: 'Amount',
      propName: 'amount',
      required: true,
      requiredMsg: 'Amount is required',
    },
    {
      dataType: 'TextArea',
      placeholder: 'Description',
      propName: 'description',
      required: false,
    },
  ];

  return columns;
};
